import { styled } from "../../../styles";

/**
 * Styles for the /admin Wards group — the ward list and details (EN-5151)
 * and Ward × Measurement Types (EN-5157). Generic admin chrome lives in
 * `shared/AdminPage.styles.ts`; only pieces specific to these pages go here.
 */

/** Prose inside a confirmation modal. */
export const ModalBodyText = styled("p", {
  margin: 0,
  fontSize: "14px",
  lineHeight: 1.5,
  color: "$charcoal",
  fontFamily: "$openSans",
});

/** Per-row text button in a table's action column. */
/** Holds the two row actions side by side without wrapping. */
export const RowActions = styled("div", {
  display: "flex",
  gap: "6px",
  justifyContent: "flex-end",
});
